export const CHUNK_SIZE = 256;   // metres
export const CELL_SIZE = 0.25;   // metres
export const CHUNK_CELLS = CHUNK_SIZE / CELL_SIZE;
export const CHUNK_VERTS = CHUNK_CELLS + 1;
